import Modal from 'modal-enhanced-react-native-web'
import React, { useMemo } from 'react'
import { Platform, ScrollView, View } from 'react-native'
import { Divider, Text } from 'react-native-paper'
import { IconCloseDrawer } from '../../assets/icons'
import { TouchableOpacity } from 'react-native-web'
import { helpers, theme } from '@linqpal/common-frontend'
import { PopupMessageContained } from '../molecules/PopupMessageContained'

const { commonColors } = theme
const { composeStyle } = helpers

export default ({
  children,
  onClose,
  visible,
  style,
  title,
  subTitle,
  width = 622,
  footer,
  footerStyle,
  header,
  customSidebarStyles = {},
  customPadding = false,
  divider = true,
  ...rest
}) => {
  const HEADER_HEIGHT = 100
  const FOOTER_HEIGHT = footerStyle?.height ?? 100

  const onKeyDown = (event) => {
    /**
     * Multiple calls on onClose will cause unwanted behaviour, sidebar won't close completely in some cases.
     */
    if (event.keyCode === 27 && visible) {
      onClose()
    }
  }

  React.useEffect(() => {
    if (Platform.OS === 'web') {
      document.addEventListener('keydown', onKeyDown, false)
    }

    return () => {
      if (Platform.OS === 'web') {
        document.removeEventListener('keydown', onKeyDown, false)
      }
    }
  }, [])

  let scrollView
  React.useEffect(() => {
    if (!scrollView || !visible) return
    scrollView.scrollTo({ x: 0, y: 0, animated: false })
  }, [visible])

  const HEIGHT = window.innerHeight

  const t = useMemo(() => {
    if (!title) return null
    if (typeof title === 'object') return title
    return <Text style={{ fontSize: 20, fontWeight: '500' }}>{title}</Text>
  }, [title])

  const st = useMemo(() => {
    if (!subTitle) return null
    if (typeof subTitle === 'object') return subTitle
    return <Text style={{ color: commonColors.tertiaryDark }}>{subTitle}</Text>
  }, [subTitle])

  if (!visible) return null

  return (
    <Modal
      isVisible={visible}
      onBackdropPress={onClose}
      onBackButtonPress={onClose}
      {...rest}
      animationIn="slideInRight"
      animationOut="slideOutRight"
      animationInTiming={400}
      animationOutTiming={300}
      style={{ marginLeft: window.innerWidth - width }}
    >
      <View
        style={[
          { width: width, height: HEIGHT, backgroundColor: 'white' },
          style,
        ]}
      >
        {header || (
          <View
            style={{
              paddingTop: 24,
              paddingHorizontal: 24,
              flexDirection: 'row',
              height: HEADER_HEIGHT,
            }}
          >
            <View style={{ flex: 1 }}>
              {st}
              {t}
            </View>
            <TouchableOpacity onPress={onClose} testID="close_sidebar_button">
              <IconCloseDrawer />
            </TouchableOpacity>
          </View>
        )}

        <View style={{ height: HEIGHT - HEADER_HEIGHT - FOOTER_HEIGHT }}>
          <ScrollView
            style={{ paddingHorizontal: customPadding ? customPadding : 20 }}
            ref={(ref) => (scrollView = ref)}
          >
            {children}
          </ScrollView>
        </View>
        {!!footer && (
          <>
            {divider && <Divider />}
            <View
              style={composeStyle(
                {
                  height: FOOTER_HEIGHT,
                  padding: 24,
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                },
                footerStyle,
              )}
            >
              {footer}
            </View>
          </>
        )}
      </View>
      <PopupMessageContained wrapperStyle={{ marginLeft: 100 }} />
    </Modal>
  )
}
